import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { createRequestOption } from 'app/shared/util/request-util';
import { ISystemConfigRx } from 'app/shared/model/system-config-rx.model';
import { LocalStorageService } from 'ngx-webstorage';
import AppConfigService from 'app/core/app-config.service';

type EntityResponseType = HttpResponse<ISystemConfigRx>;
type EntityArrayResponseType = HttpResponse<ISystemConfigRx[]>;

@Injectable({ providedIn: 'root' })
export default class SystemConfigRxService {
  public resourceUrl = `${AppConfigService.envConfig.fssServicesBaseUrl}api/system-configs`;

  public systemConfigDetailUrl = `${AppConfigService.envConfig.fssServicesBaseUrl}api/config-detail`;

  constructor(protected http: HttpClient, private $localStorage: LocalStorageService) {}

  create(systemConfig: ISystemConfigRx): Observable<EntityResponseType> {
    return this.http.post<ISystemConfigRx>(this.resourceUrl, systemConfig, { observe: 'response' });
  }

  update(systemConfig: ISystemConfigRx): Observable<EntityResponseType> {
    return this.http.put<ISystemConfigRx>(this.resourceUrl, systemConfig, { observe: 'response' });
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<ISystemConfigRx>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ISystemConfigRx[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  getConfigDetail(codes: string): Observable<HttpResponse<any>> {
    return this.http.get<ISystemConfigRx[]>(`${this.systemConfigDetailUrl}/${encodeURIComponent(codes)}`, { observe: 'response' });
  }

  getConfigValueFromLocalStorage(code) {
    const sysconfig = JSON.parse(this.$localStorage.retrieve('sysconfig'));
    if (sysconfig) {
      const info: ISystemConfigRx[] = sysconfig.filter((e) => e.systemCode === code);
      if (info.length > 0) {
        return info[0]?.systemValue;
      }
    }

    return '';
  }
}
